import { Controller } from '@hotwired/stimulus';

// Controller to handle hiding a modal.
export default class ModalController extends Controller {
  hide(): void {
    this.element.classList.add('hidden');
  }
}
